<template>
  <div class="container-fluid px-0">
    <div class="row justify-content-between">
      <div class="col-md-3 mb-4">
        <div
          class="card card-summary border-radius-15 bg-gray-400 border-no-radius h-100 pb-1 px-3 pt-3"
          v-loading="loading"
          style="min-height: 157px"
        >
          <div
            class="card-icon d-flex justify-content-between my-2 align-items-center"
          >
            <span class="card-text">Total People</span>
            <UsersIcon class="w-12 h-12 text-dak" />
          </div>
          <div class="card-content mt-4">
            <div class="mb-2">
              <h3 class="card-title font-weight-600">
                {{
                  tenantInfo && tenantInfo.memberCount
                    ? tenantInfo.memberCount.toLocaleString()
                    : 0
                }}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 mb-4">
        <div
          class="card card-summary border-radius-15 bg-gray-400 border-no-radius h-100 pb-1 px-3 pt-3"
          v-loading="loading"
          style="min-height: 157px"
        >
          <div
            class="card-icon d-flex justify-content-between align-items-center my-2"
          >
            <span class="card-text">Average Attendance</span>
            <PersonSimpleWalkIcon class="w-12 h-12 text-dak" />
          </div>
          <div class="card-content mt-4">
            <div class="mb-2">
              <h3 class="card-title font-weight-600">
                {{ getAllAverageAttendance.toLocaleString() }}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 mb-4">
        <div
          class="card card-summary border-radius-15 bg-gray-400 border-no-radius h-100 pb-1 px-3 pt-3"
          v-loading="loading"
          style="min-height: 157px"
        >
          <div
            class="card-icon d-flex justify-content-between align-items-center my-2"
          >
            <span class="card-text">Average Income</span>
            <ArrowDownIcon class="w-12 h-12 text-dak" />
          </div>
          <div class="card-content mt-4">
            <div class="mb-2">
              <h3
                class="card-title font-weight-600"
                style="color: #01832d !important"
              >
                {{
                  Math.round(
                    singleBranchInfo.currentYearAverageIncome
                  ).toLocaleString()
                }}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 mb-4">
        <div
          class="card card-summary border-radius-15 bg-gray-400 border-no-radius h-100 pb-1 px-3 pt-3"
          v-loading="loading"
          style="min-height: 157px"
        >
          <div
            class="card-icon d-flex justify-content-between align-items-center my-2"
          >
            <span class="card-text"> Average Expense</span>
            <ArrowUpIcon class="w-12 h-12 text-dak" />
          </div>
          <div class="card-content mt-4">
            <div class="mb-2">
              <h3
                class="card-title font-weight-600"
                style="color: #f51818 !important"
              >
                {{
                  Math.round(
                    singleBranchInfo.currentYearAverageExpense
                  ).toLocaleString()
                }}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid px-0">
    <div class="row mt-4">
      <div class="col-md-12 d-none d-md-block">
        <div
          class="col-md-12 px-3 py-4"
          style="background: #f8f8f8; border-radius: 15px"
        >
          <div class="row justify-content-center">
            <div
              class="text-head col-md-12 px-4 font-weight-bold"
              style="font-size: 18px"
            >
              <!-- {{
                navigatorLang === "en-US"
                  ? "Quick Things you can do"
                  : $t("dashboard.quickThings.text-head")
              }} -->
              Quick report you can view
            </div>
          </div>
          <div class="row mt-2 justify-content-center">
            <div
              class="col-md-12 px-4 d-flex justify-content-between flex-wrap"
            >
              <div>
                <div class="quick-btn-link" @click="incomeExpReport">
                  <el-button link>
                    <span class=""> Income & Expense</span>
                    <CurrencyCircleDollarIcon class="w-12 h-12 primary--text" />
                  </el-button>
                </div>
              </div>
              <div>
                <div class="quick-btn-link" @click="offerinConReport">
                  <el-button link>
                    <span class=""> Offering & Contribution</span>
                    <CurrencyCircleDollarIcon class="w-12 h-12 primary--text" />
                  </el-button>
                </div>
              </div>
              <div>
                <div @click="membershipReports" class="quick-btn-link">
                  <el-button link>
                    <span class=""> Membership </span>
                    <UserIcon class="w-12 h-12 primary--text" />
                  </el-button>
                </div>
              </div>
              <div>
                <div class="quick-btn-link">
                  <el-button size="large" link @click="serviceReports">
                    <span class=""> Service reports</span>
                    <ScrollIcon class="w-12 h-12 primary--text" />
                  </el-button>
                </div>
              </div>
              <div>
                <div class="quick-btn-link">
                  <el-button link @click="attendanceReports">
                    <span class="">Attendance </span>
                    <PersonSimpleWalkIcon class="w-12 h-12 primary--text" />
                  </el-button>
                </div>
              </div>

              <div>
                <div class="quick-btn-link">
                  <el-button size="large" link @click="allReport">
                    <span class=""> All Reports</span>
                    <InfoIcon class="w-12 h-12 primary--text" />
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 d-block d-md-none mt-3">
        <div
          class="col-md-12 px-3 py-4"
          style="background: #f8f8f8; border-radius: 15px"
        >
          <div class="row justify-content-center">
            <div
              class="text-head col-md-12 px-4 font-weight-bold"
              style="font-size: 18px"
            >
              Quick report you can view
            </div>
          </div>
          <div class="row mt-2 justify-content-center">
            <div
              class="col-md-12 px-4 d-flex justify-content-between flex-wrap"
            >
              <div>
                <div class="quick-btn-link" @click="incomeExpReport">
                  <el-button link>
                    <span class=""> Income & Expense </span>
                    <CurrencyCircleDollarIcon class="w-12 h-12 primary--text" />
                  </el-button>
                </div>
              </div>
              <div>
                <div class="quick-btn-link" @click="offerinConReport">
                  <el-button link>
                    <span class=""> Offering & Contribution</span>
                    <CurrencyCircleDollarIcon class="w-12 h-12 primary--text" />
                  </el-button>
                </div>
              </div>
              <div>
                <div @click="membershipReports" class="quick-btn-link">
                  <el-button link>
                    <span class=""> Membership</span>
                    <UserIcon class="w-12 h-12 primary--text" />
                  </el-button>
                </div>
              </div>
              <div>
                <div class="quick-btn-link">
                  <el-button size="large" link @click="serviceReports">
                    <span class=""> Service reports</span>
                    <ScrollIcon class="w-12 h-12 primary--text" />
                  </el-button>
                </div>
              </div>
              <div>
                <div class="quick-btn-link">
                  <el-button link @click="attendanceReports">
                    <span class="">Attendance</span>
                    <PersonSimpleWalkIcon class="w-12 h-12 primary--text" />
                  </el-button>
                </div>
              </div>

              <div>
                <div class="quick-btn-link">
                  <el-button size="large" link @click="allReport">
                    <span class=""> All Reports</span>
                    <InfoIcon class="w-12 h-12 primary--text" />
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid px-0 mt-4">
    <div class="row">
      <div class="col-8 offset-2 offset-md-0 col-md-3 ">
        <!-- <div
        class="col-8 offset-2 offset-md-0 col-md-3 p-0"
        v-if="
          (tenantInfoFirstTimerWeekly[0] &&
            tenantInfoFirstTimerWeekly[0].data.some((i) => i > 0)) ||
          (tenantInfoAttendanceWeekly[0] &&
            tenantInfoAttendanceWeekly[0].data.some((i) => i > 0))
        "
      > -->
        <div @click="routeToWelcomeOnboard" class="cursor-pointer">
          <el-carousel :interval="5000" arrow="always">
            <el-carousel-item v-for="(item, index) in images" :key="index">
              <!-- <h3 text="2xl" justify="center">{{ item }}</h3> -->
              <img :src="item.image" class="w-100 my-4" />
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- <div @click="showWemaOfferUpdate" class="cursor-pointer">
          <img src="../../assets/wemachurchplus.png" class="w-100 my-4" />
        </div> -->
        <!-- <div @click="showSubOfferUpdate">
                <img src="../../assets/Exclusive.jpg" class="w-100 my-4" />
              </div> -->
        <!-- <div @click="showSMSUpdate" class="cursor-pointer">
                <img src="../../assets/SMSUpdate.jpg" class="w-100 my-4" />
              </div> -->
        <!-- <div
                class="more-things sid p-3 mb-3 cursor-pointer"
                v-if="!tenantInfoExtra.hasMobileApp"
                @click="routeToWelcomeOnboard"
              >
                <img src="../../assets/mobileapp2.svg" class="w-100" />
                <img src="../../assets/mobileonboarding/PickDashboardMobileApp.jpg" class="w-100" />
                <div class="mt-4 can-do text-head h5 font-weight-600">
                  {{
                    navigatorLang === "en-US"
                      ? "Mobile App"
                      : $t("dashboard.MobileApp")
                  }}
                </div>
                <div class="more-body mt-2">
                  {{
                    navigatorLang === "en-US"
                      ? "Get a customized mobile app for your church."
                      : $t("dashboard.GetCustomizedMobile")
                  }}
                </div>
                <div class="no-decoration">
                  <el-button
                    class="mt-1 bg-warning text-white"
                    @click="routeToWelcomeOnboard"
                    round
                    >{{
                      navigatorLang === "en-US"
                        ? "Set up now"
                        : $t("dashboard.SetUpNow")
                    }}</el-button
                  >
                </div>
              </div> -->
        <!-- <div class="more-things side p-3" v-if="!tenantInfoExtra.hasWebsite">
          <img src="../../assets/website2.svg" class="w-100" />
          <div class="mt-4 can-do text-head h5 font-weight-600">
            {{
              navigatorLang === "en-US" ? "Website" : $t("dashboard.Website")
            }}
          </div>
          <div class="more-body mt-2">
            {{
              navigatorLang === "en-US"
                ? "Get a user engaging website for your church."
                : $t("dashboard.EngagingWebsite")
            }}
          </div>
          <a
            href="https://churchplus.co/awoofwebsite/"
            target="_blank"
            class="no-decoration"
          >
            <el-button class="mt-1" round>{{
              navigatorLang === "en-US" ? "Get one now" : $t("dashboard.GetNow")
            }}</el-button>
          </a>
        </div> -->

        <!-- <div
          class="more-things side p-3 mt-4"
          v-if="!tenantInfoExtra.hasOnlineGiving"
        >
          <img src="../../assets/onlinegiving2.svg" class="w-100" />
          <div class="mt-4 can-do text-head h5 font-weight-600">
            {{
              navigatorLang === "en-US"
                ? "Online Giving"
                : $t("dashboard.OnlineGiving")
            }}
          </div>
          <div class="more-body mt-2">
            {{
              navigatorLang === "en-US"
                ? "Make online donations to your church."
                : $t("dashboard.makeOnlineDonations")
            }}
          </div>
          <div class="no-decoration">
            <el-button class="mt-1" @click="routeToPayment" round>{{
              navigatorLang === "en-US"
                ? "Set up now"
                : $t("dashboard.SetUpNow")
            }}</el-button>
          </div>
        </div> -->
      </div>

      <!-- <div
        :class="{
          'col-12 col-md-9':
            !tenantInfoExtra.hasMobileApp ||
            !tenantInfoExtra.hasOnlineGiving ||
            !tenantInfoExtra.hasWebsite,
          'col-md-12 px-0':
            tenantInfoExtra.hasMobileApp &&
            tenantInfoExtra.hasOnlineGiving &&
            tenantInfoExtra.hasWebsite,
        }"
      > -->
      <div class="col-12 col-md-9">
        <div
          v-show="
            (tenantInfoFirstTimerWeekly[0] &&
              tenantInfoFirstTimerWeekly[0].data.length > 0) ||
            (tenantInfoFirstTimerWeekly[0] &&
              tenantInfoFirstTimerWeekly[0].data[0] > 0) ||
            (tenantInfoAttendanceWeekly[0] &&
              tenantInfoAttendanceWeekly[0].data.length > 0) ||
            (tenantInfoIncomeExpenseWeekly[0] &&
              tenantInfoIncomeExpenseWeekly[0].data[0] > 0)
          "
        >
          <div v-if="tenantInfoIncomeExpenseWeekly && incomeExpenseDataExist">
            <div class="view-report">
              <div
                class="adjust-view col-10 col-sm-12 d-flex justify-content-end"
              >
                <!-- <div class="view-report">View Reports</div> -->
                <div class="weekly col-md-5 d-flex">
                  <div
                    class="week col-md-6 border py-2 px-4"
                    :class="{
                      active: incomeExpenseBoolean,
                      active2: !incomeExpenseBoolean,
                    }"
                    @click="weeklyIncomeExpense"
                  >
                    {{
                      navigatorLang === "en-US"
                        ? "Weekly"
                        : $t("dashboard.Weekly")
                    }}
                  </div>
                  <div
                    class="month col-md-6 border py-2 px-4"
                    :class="{
                      active3: incomeExpenseBooleanMont,
                      active4: !incomeExpenseBooleanMont,
                    }"
                    @click="monthlyIncomeExpense"
                  >
                    {{
                      navigatorLang === "en-US"
                        ? "Monthly"
                        : $t("dashboard.Monthly")
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div v-if="incomeExpenseBoolean">
              <ColumnChart
                domId="chart5"
                title="Income vs Expense flow"
                subtitle=""
                header="Income vs Expense"
                :data="incomeExpenseWeeklyData"
                :series="series3"
                :attendanceSeries="incomeExpenseSeries"
              />
            </div>
            <div v-else class="ColumnChartDiv">
              <ColumnChart
                domId="chart5"
                title="Income vs Expense flow"
                subtitle=""
                header="Income vs Expense"
                :data="incomeExpenseMonthlyData"
                :series="series3"
                :attendanceSeries="incomeExpenseSeries"
              />
            </div>
          </div>
          <div class="row mt-5" v-loading="loading">
            <div class="col-md-12" v-if="true" v-loading="loading">
              <div class="col-md-12 border pl-4 rounded-lg">
                <div class="row mt-3">
                  <div class="col-md-12 d-flex justify-content-between">
                    <div
                      style="color: #01832d !important"
                      class="s-18 font-weight-600"
                    >
                      Income Breakdown
                    </div>
                    <!-- <div class="d-flex justify-content-between">
                      <div class="font-weight-bold s-16 primary--text mr-3">
                        This Year
                      </div>
                      <div class="fw-400 s-16 text-dak">This Month</div>
                    </div> -->
                  </div>
                  <div class="col-md-12">
                    <DonutChart2
                      domId="incomedomId"
                      :colour="incomeColour"
                      :seriesData="
                        incomeBreakDownChartData ? incomeBreakDownChartData : []
                      "
                      title=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 mt-4" v-if="true" v-loading="loading">
              <div class="col-md-12 border pl-4 rounded-lg">
                <div class="row mt-3">
                  <div class="col-md-12 d-flex justify-content-between">
                    <div
                      style="color: #f51818 !important"
                      class="s-18 font-weight-600"
                    >
                      Expense Breakdown
                    </div>
                    <!-- <div class="d-flex justify-content-between">
                      <div class="font-weight-bold s-16 primary--text mr-3">
                        This Year
                      </div>
                      <div class="fw-400 s-16 text-dak">This Month</div>
                    </div> -->
                  </div>
                  <div class="col-md-12">
                    <DonutChart2
                      domId="expensedomId"
                      :colour="expenseColour"
                      :seriesData="
                        expenseBreakDownChartData
                          ? expenseBreakDownChartData
                          : []
                      "
                      title=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="tenantInfoAttendanceWeekly && attendanceDataExist">
            <div class="view-report">
              <div
                class="adjust-view2 col-10 col-sm-12 px-0 d-flex justify-content-end mt-5 mt-md-0"
              >
                <!-- <div class="view-report">View Reports</div> -->
                <div class="weekly col-md-5 d-flex">
                  <div
                    class="week col-md-6 border py-2 px-4"
                    :class="{
                      active: attendanceBoolean,
                      active2: !attendanceBoolean,
                    }"
                    @click="weeklyAttendance"
                  >
                    {{
                      navigatorLang === "en-US"
                        ? "Weekly"
                        : $t("dashboard.Weekly")
                    }}
                  </div>
                  <div
                    class="month col-md-6 border py-2 px-4"
                    :class="{
                      active3: attendanceBooleanMont,
                      active4: !attendanceBooleanMont,
                    }"
                    @click="monthlyAttendance"
                  >
                    {{
                      navigatorLang === "en-US"
                        ? "Monthly"
                        : $t("dashboard.Monthly")
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div v-if="attendanceBoolean" class="mt-4">
              <ColumnChart
                domId="chart1"
                title="Event Attendance"
                subtitle="Weekly Attendance of Events"
                header="Members Attendance"
                :data="chartData"
                :series="series"
                :attendanceSeries="attendanceSeries"
              />
            </div>
            <div v-if="attendanceBooleanMont" class="mt-4">
              <ColumnChart
                domId="chart1"
                title="Event Attendance"
                subtitle="Monthly Attendance of Events"
                header="Members Attendance"
                :data="monthlyAttendanceObj"
                :series="series"
                :attendanceSeries="attendanceSeries"
              />
            </div>
          </div>

          <div v-if="tenantInfoFirstTimerWeekly && firstTimerDataExist">
            <div class="view-report">
              <div
                class="adjust-view col-10 col-sm-12 d-flex justify-content-end"
              >
                <!-- <div class="view-report">View Reports</div> -->
                <div class="weekly col-md-5 d-flex">
                  <div
                    class="week col-md-6 border py-2 px-4"
                    :class="{
                      active: firstTimerBoolean,
                      active2: !firstTimerBoolean,
                    }"
                    @click="weeklyFirstTimer"
                  >
                    {{
                      navigatorLang === "en-US"
                        ? "Weekly"
                        : $t("dashboard.Weekly")
                    }}
                  </div>
                  <div
                    class="month col-md-6 border py-2 px-4"
                    :class="{
                      active3: firstTimerBooleanMont,
                      active4: !firstTimerBooleanMont,
                    }"
                    @click="monthlyFirstTimer"
                  >
                    {{
                      navigatorLang === "en-US"
                        ? "Monthly"
                        : $t("dashboard.Monthly")
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div v-if="firstTimerBoolean">
              <ColumnChart
                domId="chart3"
                title="First Timer Inflow"
                subtitle="How First Timers Come to Church"
                header="First Timers Attendance"
                :data="chartData2"
                :series="series2"
                :attendanceSeries="attendanceSeries"
              />
            </div>
            <div v-else class="ColumnChartDiv">
              <ColumnChart
                domId="chart4"
                title="First Timer Inflow"
                subtitle="How First Timer Come to Church"
                header="First Timers Attendance"
                :data="monthlyFirstTimerObj"
                :series="series2"
                :attendanceSeries="attendanceSeries"
              />
            </div>
          </div>

          <!-- <div class="mt-4" v-show="firstTimerPieExist">
            <div class="">
              <div class="row">
                <div class="col-12 col-md-6 d-flex justify-content-center">
                  <ByGenderChart
                    domId="source"
                    title="Invitation Source"
                    distance="5"
                    :titleMargin="10"
                    :summary="
                      tenantInfoInvitationSource
                        ? tenantInfoInvitationSource
                        : []
                    "
                  />
                </div>
                <div
                  class="col-12 col-md-6 mt-3 mt-md-0 d-flex justify-content-center"
                >
                  <ByMaritalStatusChart
                    domId="join"
                    title="Interested In Joining"
                    :titleMargin="10"
                    :summary="
                      tenantInfoInterestedInJoining
                        ? tenantInfoInterestedInJoining
                        : []
                    "
                  />
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="
      tenantInfoFirstTimerWeekly[0] &&
      tenantInfoFirstTimerWeekly[0].data.every((i) => i === 0) &&
      tenantInfoAttendanceWeekly[0] &&
      tenantInfoAttendanceWeekly[0].data.every((i) => i === 0) &&
      tenantInfoIncomeExpenseWeekly[0] &&
      tenantInfoIncomeExpenseWeekly[0].data.every((i) => i === 0)
    "
  >
    <div class="container-fluid mt-5">
      <div class="row">
        <div class="col-12 more-things">
          <div class="can-do text-head">
            <h4>
              {{
                navigatorLang === "en-US"
                  ? "More Benefits You Can Get"
                  : $t("dashboard.MoreBenefits")
              }}
            </h4>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12 col-sm-6 col-md-4 more-things">
          <img src="../../assets/mobileapp2.svg" />
          <div class="mt-4">
            <div class="can-do text-head">
              <h4>
                {{
                  navigatorLang === "en-US"
                    ? "Mobile app"
                    : $t("dashboard.MobileApp")
                }}
              </h4>
            </div>
          </div>
          <div class="more-body mt-2">
            {{
              navigatorLang === "en-US"
                ? "Get a customized mobile app for your church."
                : $t("dashboard.GetCustomizedMobile")
            }}
          </div>
          <div class="no-decoration">
            <el-button
              class="mt-1 bg-warning text-white"
              @click="routeToWelcomeOnboard"
              round
              >{{
                navigatorLang === "en-US"
                  ? "Set up now"
                  : $t("dashboard.SetUpNow")
              }}</el-button
            >
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-4 mt-5 mt-md-0 more-things">
          <img src="../../assets/website2.svg" />
          <div class="mt-4">
            <div class="can-do text-head">
              <h4>
                {{
                  navigatorLang === "en-US"
                    ? "Website"
                    : $t("dashboard.Website")
                }}
              </h4>
            </div>
          </div>
          <div class="more-body mt-2">
            {{
              navigatorLang === "en-US"
                ? "Get a user engaging website for your church."
                : $t("dashboard.EngagingWebsite")
            }}
          </div>
          <a
            href="https://churchplus.co/awoofwebsite/"
            class="no-decoration"
            target="_blank"
          >
            <el-button class="mt-1" round>{{
              navigatorLang === "en-US" ? "Get one now" : $t("dashboard.GetNow")
            }}</el-button>
          </a>
        </div>
        <div class="col-12 col-sm-6 col-md-4 mt-5 mt-sm-0 more-things second">
          <img src="../../assets/onlinegiving2.svg" />
          <div class="mt-4">
            <div class="can-do text-head">
              <h4>
                {{
                  navigatorLang === "en-US"
                    ? "Online giving"
                    : $t("dashboard.OnlineGiving")
                }}
              </h4>
            </div>
          </div>
          <div class="more-body mt-2">
            {{
              navigatorLang === "en-US"
                ? "Allow members to make online donations to your church."
                : $t("dashboard.AllowMembers")
            }}
          </div>
          <div class="no-decoration">
            <el-button class="mt-1" @click="routeToPayment" round>{{
              navigatorLang === "en-US"
                ? "Set up now"
                : $t("dashboard.SetUpNow")
            }}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    v-if="!loading && !networkError && !tenantInfo"
    class="no-person w-100 mt-4"
  >
    <div class="empty-img">
      <p><img src="../../assets/people/people-empty.svg" alt="" /></p>
      <p class="tip">No Record Found for this branch</p>
    </div>
  </div>
  <div class="adjust-network" v-else-if="networkError">
    <img src="../../assets/network-disconnected.png" />
    <div>Opps, Your internet connection was disrupted</div>
  </div>
  <el-drawer
    v-model="showSMS"
    :size="mdAndUp || lgAndUp || xlAndUp ? '70%' : '100%'"
    direction="rtl"
  >
    <template #header>
      <h4>Send SMS</h4>
    </template>
    <template #default>
      <div>
        <smsComponent @closesidemodal="() => (showSMS = false)" />
      </div>
    </template>
  </el-drawer>
  <el-drawer
    v-model="showEmail"
    :size="mdAndUp || lgAndUp || xlAndUp ? '70%' : '100%'"
    direction="rtl"
  >
    <template #header>
      <h4>Send Email</h4>
    </template>
    <template #default>
      <div>
        <emailComponent @closesidemodal="() => (showEmail = false)" />
      </div>
    </template>
  </el-drawer>
  <el-drawer
    v-model="showWhatsapp"
    :size="mdAndUp || lgAndUp || xlAndUp ? '70%' : '100%'"
    direction="rtl"
  >
    <template #default>
      <div>
        <whatSappComponent @closesidemodal="() => (showWhatsapp = false)" />
      </div>
    </template>
  </el-drawer>
</template>

<script>
import { ref, inject, onMounted, watchEffect, computed } from "vue";
import ColumnChart from "@/components/charts/ColumnChart.vue";
// import ColumnChart from "@/components/charts/SingleBranchChart.vue";
import DonutChart2 from "@/components/charts/DonutChart2.vue";
import axios from "@/gateway/backendapi";
import smsComponent from "../groups/component/smsComponent.vue";
import emailComponent from "../groups/component/emailComponent.vue";
import whatSappComponent from "../groups/component/whatSappComponent.vue";
import { socket } from "@/socket";
import ArrowUpIcon from "../../components/icons/ArrowUpIcon.vue";
import ArrowDownIcon from "../../components/icons/ArrowDownIcon.vue";
import PersonSimpleWalkIcon from "../../components/icons/PersonSimpleWalkIcon.vue";
import UsersIcon from "../../components/icons/UsersIcon.vue";
import CurrencyCircleDollarIcon from "../../components/icons/CurrencyCircleDollarIcon.vue";
import InfoIcon from "../../components/icons/InfoIcon.vue";
import deviceBreakpoint from "../../mixins/deviceBreakpoint";
import store from "../../store/store";
import swal from "sweetalert";
import UserIcon from "../../components/icons/UserIcon.vue";
import ArrowFatLinesUpIcon from "../../components/icons/ArrowFatLinesUpIcon.vue";
import ScrollIcon from "../../components/icons/ScrollIcon.vue";
import router from "../../router";
export default {
  components: {
    DonutChart2,
    UsersIcon,
    ArrowUpIcon,
    PersonSimpleWalkIcon,
    ArrowDownIcon,
    ColumnChart,
    whatSappComponent,
    smsComponent,
    emailComponent,
    InfoIcon,
    ScrollIcon,
    ArrowFatLinesUpIcon,
    UserIcon,
    CurrencyCircleDollarIcon,
  },
  setup() {
    const selectedAction = ref("Quick Action");
    const firstTimerHeader = ref("First Timer Attendance");
    const MemberAttendanceHeader = ref("Members Attendance");
    const attendanceBoolean = ref(true);
    const attendanceBooleanMont = ref(false);
    const firstTimerBooleanMont = ref(false);
    const incomeExpenseBooleanMont = ref(false);
    const incomeExpenseBoolean = ref(true);
    const firstTimerBoolean = ref(true);
    const selectedMonthly = ref("Monthly");
    const selectedWeekly = ref("Monthly");
    const primarycolor = inject("primarycolor");
    const IncomeExpHeader = ref("Income & Expenses");
    const branchId = ref("");
    const loading = ref(false);
    const getAllAverageIncome = ref("");
    const getAllAverageAttendance = ref("");
    const getTotalPeople = ref("");
    const allBranches = ref([]);
    const expenseData = ref([]);
    const incomeData = ref([]);
    const series = ref([]);
    const showWhatsapp = ref(false);
    const mainIncomeExpenseData = ref([]);
    const firstTimerAttendanceData = ref([]);
    const tenantInfoFirstTimerWeekly = ref([]);
    const tenantInfoFirstTimerMonthly = ref([]);
    const tenantInfoAttendanceWeekly = ref([]);
    const tenantInfoAttendanceMonthly = ref([]);
    const tenantInfoIncomeExpenseMonthly = ref([]);
    const tenantInfoIncomeExpenseWeekly = ref([]);
    const tenantInfoExpenseBreakDown = ref([]);
    const tenantInfoIncomeBreakDown = ref([]);
    const sendingwhatsappmessage = ref(false);
    const firstTimerWeeklyAtt = ref(false);
    const attendancerWeeklyAtt = ref(false);
    const attendancerMonthlyAtt = ref(false);
    const sendWhatsappToMultiple = ref(false);
    const networkError = ref(false);
    const xAxis = ref([]);
    const firstTimerMonthlyAtt = ref(true);
    const firstTimerData = ref([]);
    const firstTimerDataExist = ref(false);
    const attendanceDataExist = ref(false);
    const MemberAttDataExist = ref(false);
    const incomeExpenseDataExist = ref(false);
    const showEmail = ref(false);
    const showSMS = ref(false);
    const singleBranchInfo = ref({});
    const incomeExpenseSeries = ref("weekly");
    const attendanceSeries = ref("weekly");
    const firstTimerSeries = ref("weekly");
    const expenseColour = ref([
      "#D63031", // red
      "#E17055", // orange
      "#E74C3C", // soft red
      "#FD7272", // light red
      "#F39C12", // gold/orange
      "#E67E22", // tangerine
      "#C0392B", // dark red
      "#FF7675", // pinkish red
      "#FF6B6B", // coral red
    ]);
    const incomeColour = ref([
      "#00B894", // teal
      "#0984E3", // vivid blue
      "#00CEC9", // cyan
      "#55EFC4", // mint
      "#81ECEC", // sky blue
      "#1ABC9C", // emerald
      "#2ECC71", // green
      "#74B9FF", // light blue
      "#A29BFE", // soft purple
    ]);
    const navigatorLang = ref(navigator.language);
    const tenantInfo = ref({});
    const { mdAndUp, lgAndUp, xlAndUp, xsOnly } = deviceBreakpoint();
    const branchItem = ref(store.getters.currentBranch);
    console.log(store.getters.currentBranch, "i have more than a soing");
    const monthXaxis = ref([
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ]);
    const donutData = ref([
      { name: "Expense1", y: 60090, color: "#01058A" },
      { name: "Expense3", y: 64300, color: "#01458A" },
      { name: "Expense2", y: 20000, color: "#01028A" },
      { name: "Expense4", y: 6200, color: "#01058A" },
      { name: "Expense5", y: 64000, color: "#01428A" },
      { name: "Expense6", y: 20800, color: "#01088A" },
    ]);
    const donutData2 = ref([
      { name: "Income", y: 60000, color: "#01058A" },
      { name: "income2", y: 64000, color: "#01458A" },
      { name: "Incom3", y: 23000, color: "#01028A" },
      { name: "Incom4", y: 20300, color: "#01228A" },
      { name: "Incom5", y: 20500, color: "#01058A" },
      { name: "Incom6", y: 20040, color: "#01088A" },
      { name: "Incom7", y: 20800, color: "#01038A" },
    ]);
    const images = ref([
      {
        id: 1,
        image: require("../../assets/mobileonboarding/DashboardMobileApp.jpg"),
      },
      {
        id: 2,
        image: require("../../assets/mobileonboarding/PickDashboardMobileApp.jpg"),
      },
      {
        id: 3,
        image: require("../../assets/mobileonboarding/DashboardMobileApp3.jpg"),
      },
    ]);

    const attendanceReports = () => {
      router.push("/tenant/reports/attendancereport");
    };
    const serviceReports = () => {
      router.push("/tenant/reports/attendanceperformancereport");
    };
    const membershipReports = () => {
      router.push("/tenant/reports/membershipreport");
    };
    const offerinConReport = () => {
      router.push("/tenant/reports/offeringfinancialreport");
    };
    const incomeExpReport = () => {
      router.push("/tenant/reports/incomestatement");
    };
    const allReport = () => {
      router.push("/tenant/reports");
    };

    const getBranchItem = () => {
      branchItem.value = store.getters.currentBranch;
      console.log(branchItem.value, "lllll");
    };
    getBranchItem();

    onMounted(() => {
      const branchID = localStorage.getItem("branchId");
      const branchItem = localStorage.getItem("branchItem");
      branchId.value = branchID;
      console.log(branchItem, "jhghk");

      // if (branchItem.value && Object.keys(branchItem.value).length == 0)
      // getBranchItem()
    });

    // const filterNodeMethod = (value, data) =>
    //   data.label.toLowerCase().includes(value.toLowerCase());

    const series1 = computed(() => {
      if (attendanceSeries.value === "weekly") return xAxis.value;
      return monthXaxis.value;
    });

    const series2 = computed(() => {
      if (firstTimerSeries.value === "weekly") return xAxis.value;
      return monthXaxis.value;
    });
    const series3 = computed(() => {
      if (incomeExpenseSeries.value === "weekly") return xAxis.value;
      return monthXaxis.value;
    });

    onMounted(() => {
      for (let i = 1; i <= 52; i++) {
        xAxis.value.push(i);
      }
    });

    const whatsappClientState = computed(() => {
      return store.getters["communication/isWhatsappClientReady"];
    });

    const toggleSMS = (id) => {
      showSMS.value = true;
      console.log(id, "id 1");
    };
    const toggleEMAIL = (id) => {
      showEmail.value = true;
      console.log(id, "id 2");
    };

    watchEffect(() => {
      socket.on("messagesent", (data) => {
        console.log(data, "status");
        swal(" Success", "Whatsapp message sent successfully!", "success");
        showWhatsapp.value = false;
        sendingwhatsappmessage.value = false;
      });
    });
    const weeklyAttendance = () => {
      attendanceSeries.value = "weekly";
      attendanceBoolean.value = true;
      attendanceBooleanMont.value = false;
    };

    const monthlyAttendance = () => {
      attendanceSeries.value = "monthly";
      attendanceBoolean.value = false;
      attendanceBooleanMont.value = true;
    };

    const weeklyFirstTimer = () => {
      firstTimerSeries.value = "weekly";
      firstTimerBoolean.value = true;
      firstTimerBooleanMont.value = false;
    };

    const monthlyFirstTimer = () => {
      firstTimerBoolean.value = false;
      firstTimerBooleanMont.value = true;
      firstTimerSeries.value = "monthly";
    };
    const weeklyIncomeExpense = () => {
      incomeExpenseSeries.value = "weekly";
      incomeExpenseBoolean.value = true;
      incomeExpenseBooleanMont.value = false;
    };

    const monthlyIncomeExpense = () => {
      incomeExpenseSeries.value = "monthly";
      incomeExpenseBoolean.value = false;
      incomeExpenseBooleanMont.value = true;
    };

    const getBranchTenantDashboard = async () => {
      loading.value = true;
      const branchID = localStorage.getItem("branchId");
      try {
        const { data } = await axios.get(
          `api/Branching/DashboardForTenant/${branchID}`
        );
        // const { data } = await axios.get(
        //   `api/Branching/DashboardForTenant/c6eea581-ba26-4917-bff2-24e37a66a768`
        // );

        tenantInfo.value = data;
        tenantInfoAttendanceWeekly.value = data.eventAttendanceChartDataWeekly;
        tenantInfoAttendanceMonthly.value =
          data.eventAttendanceChartDataMonthly;

        tenantInfoFirstTimerWeekly.value =
          data.firstTimerSummary.firstTimerWeekly;
        tenantInfoFirstTimerMonthly.value =
          data.firstTimerSummary.firstTimerMonthly;
        tenantInfoIncomeBreakDown.value = data.incomePie.map((i) => {
          return {
            name: i.label,
            y: i.value,
          };
        });
        tenantInfoExpenseBreakDown.value = data.expensePie.map((i) => {
          return {
            name: i.label,
            y: i.value,
          };
        });

        tenantInfoIncomeExpenseMonthly.value = [
          {
            name: "Income",
            color: "#005EFF",
            data: tenantInfo.value.incomeExpenseBarMonthly.map((item) =>
              Math.abs(item.income || 0)
            ),
          },
          {
            name: "Expense",
            color: "#08A53D",
            data: tenantInfo.value.incomeExpenseBarMonthly.map((item) =>
              Math.abs(item.expense || 0)
            ),
          },
        ];

        tenantInfoIncomeExpenseWeekly.value = [
          {
            name: "Income",
            color: "#005EFF",
            data: tenantInfo.value.incomeExpenseBarWeekly.map((item) =>
              Math.abs(item.income || 0)
            ),
          },
          {
            name: "Expense",
            color: "#08A53D",
            data: tenantInfo.value.incomeExpenseBarWeekly.map((item) =>
              Math.abs(item.expense || 0)
            ),
          },
        ];

        // tenantInfoInvitationSource.value =
        //   data.firstTimerSummary.invitationSource;
        // tenantInfoInterestedInJoining.value =
        //   data.firstTimerSummary.interestedInJoining;

        tenantInfoAttendanceWeekly.value[0].data.forEach((element) => {
          if (element > 0) {
            attendanceDataExist.value = true;
          }
        });

        tenantInfoFirstTimerWeekly.value[0].data.forEach((element) => {
          if (element > 0) {
            firstTimerDataExist.value = true;
          }
        });
        tenantInfoIncomeExpenseWeekly.value[0].data.forEach((element) => {
          if (element > 0) {
            incomeExpenseDataExist.value = true;
          }
        });

        // let sum = 0;
        // tenantInfoInterestedInJoining.value.forEach((i) => {
        //   sum += +i.value;
        // });
        // if (sum > 0) {
        //   firstTimerPieExist.value = true;
        // } else {
        //   firstTimerPieExist.value = false;
        // }
        loading.value = false;
      } catch (error) {
        if (error.toString().toLowerCase().includes("network error")) {
          networkError.value = true;
        } else {
          networkError.value = false;
        }
        loading.value = false;
      }
    };
    getBranchTenantDashboard();

    const weeklyFirstTimerObj = computed(() => {
      if (!tenantInfoFirstTimerWeekly.value) return [];
      tenantInfoFirstTimerWeekly.value[0].color = "#002044";
      return tenantInfoFirstTimerWeekly.value;
    });
    const chartData2 = computed(() => {
      if (!tenantInfoFirstTimerWeekly.value) return [];
      tenantInfoFirstTimerWeekly.value[0].color = "#002044";
      return tenantInfoFirstTimerWeekly.value;
    });

    const monthlyFirstTimerObj = computed(() => {
      if (!tenantInfoFirstTimerMonthly.value) return [];
      tenantInfoFirstTimerMonthly.value[0].color = "#002044";
      return tenantInfoFirstTimerMonthly.value;
    });
    const incomeBreakDownChartData = computed(() => {
      if (!tenantInfoIncomeBreakDown.value) return [];
      return tenantInfoIncomeBreakDown.value;
    });
    const expenseBreakDownChartData = computed(() => {
      if (!tenantInfoExpenseBreakDown.value) return [];
      return tenantInfoExpenseBreakDown.value;
    });

    const incomeExpenseWeeklyData = computed(() => {
      if (!tenantInfoIncomeExpenseWeekly.value.length) return [];

      return tenantInfoIncomeExpenseWeekly.value.map((item, index) => ({
        ...item,
        color: index === 0 ? "#002044" : item.color,
      }));
    });
    const incomeExpenseMonthlyData = computed(() => {
      if (!tenantInfoIncomeExpenseMonthly.value.length) return [];

      return tenantInfoIncomeExpenseMonthly.value.map((item, index) => ({
        ...item,
        color: index === 0 ? "#002044" : item.color,
      }));
    });

    // const getBranchTenantCelebrants = async () => {
    //   const branchID = localStorage.getItem("branchId");
    //   try {
    //     const { data } = await axios.get(
    //       `/Dashboard/CelebrationsForTenant?_TenantId=${branchID}`
    //     );
    //     console.log(data, "DashboardCelebrant");
    //   } catch (error) {
    //     console.log(error);
    //   }
    // };
    // getBranchTenantCelebrants();

    // const getBranchTenantAttendance = async () => {
    //   loading.value = true;
    //   const branchID = localStorage.getItem("branchId");
    //   try {
    //     const { data } = await axios.get(
    //       `/Dashboard/AttendanceForTenant?_TenantId=${branchID}`
    //     );
    //     tenantInfoAttendanceWeekly.value =
    //       data.returnObject.eventAttendanceChartDataWeekly;
    //     tenantInfoAttendanceMonthly.value =
    //       data.returnObject.eventAttendanceChartDataMonthly;

    //     tenantInfoAttendanceMonthly.value[0].data.forEach((element) => {
    //       if (element > 0) {
    //         MemberAttDataExist.value = true;
    //       }
    //     });
    //     tenantInfoFirstTimerWeekly.value[0].data.forEach((element) => {
    //       if (element > 0) {
    //         firstTimerDataExist.value = true;
    //       }
    //     });
    //     tenantInfoAttendanceWeekly.value[0].data.forEach((element) => {
    //       if (element > 0) {
    //         attendanceDataExist.value = true;
    //       }
    //     });
    //     loading.value = false;
    //   } catch (error) {
    //     if (error.toString().toLowerCase().includes("network error")) {
    //       networkError.value = true;
    //     } else {
    //       networkError.value = false;
    //     }
    //     loading.value = false;
    //   }
    // };
    // getBranchTenantAttendance();

    const weeklyAttendanceObj = computed(() => {
      if (!tenantInfoAttendanceWeekly.value) return [];
      let chartWeekly = [];
      let chartObj = tenantInfoAttendanceWeekly.value.find(
        (i) => i.name === "Attendance"
      );
      chartObj["color"] = "#002044";
      chartWeekly.push(chartObj);
      return chartWeekly;
    });
    const chartData = computed(() => {
      if (!tenantInfoAttendanceWeekly.value) return [];
      let chartWeekly = [];
      let chartObj = tenantInfoAttendanceWeekly.value.find(
        (i) => i.name === "Attendance"
      );
      chartObj["color"] = "#002044";
      chartWeekly.push(chartObj);
      return chartWeekly;
    });
    const monthlyAttendanceObj = computed(() => {
      if (!tenantInfoAttendanceMonthly.value) return [];
      let chartMonthly = [];
      let chartObj = tenantInfoAttendanceMonthly.value.find(
        (i) => i.name === "Attendance"
      );
      chartObj["color"] = "#002044";
      chartMonthly.push(chartObj);
      return chartMonthly;
    });

    const displayWhatsappDrawer = (item) => {
      showWhatsapp.value = true;
      if (item) {
        // whatsappRecipient.value = item;
        sendWhatsappToMultiple.value = false;
      } else {
        sendWhatsappToMultiple.value = true;
      }
    };

    const getAllBranches = async () => {
      mainIncomeExpenseData.value = [];
      loading.value = true;
      try {
        let { data } = await axios.get(`/api/Branching/${branchId.value}`);

        allBranches.value = data.returnObject;
        getTotalPeople.value = data.returnObject
          .map((i) => i.membershipSize)
          .reduce((b, a) => b + a, 0);
        // getFirtTimerSeris();

        loading.value = false;
      } catch (error) {
        loading.value = false;
        console.log(error);
      }
    };
    getAllBranches();

    const geSingleBranchInfo = async () => {
      const singleBranchID = localStorage.getItem("branchId");
      loading.value = true;
      try {
        let { data } = await axios.get(
          `/api/Branching/GetBranchInformation?Id=${singleBranchID}`
        );
        singleBranchInfo.value = data.returnObject;
        getAllAverageAttendance.value =
          data.returnObject.currentYearAverageAttendance.toFixed(0);
        console.log(singleBranchInfo.value, "kksingle");
        // getFirtTimerSeris();

        loading.value = false;
      } catch (error) {
        loading.value = false;
        console.log(error);
      }
    };
    geSingleBranchInfo();

    const incomeExpenseChart = computed(() => {
      const income = singleBranchInfo.value.currentYearIncome || 0;
      const expense = singleBranchInfo.value.currentYearExpense || 0;

      return [
        {
          name: "Income",
          color: "#01058A",
          data: [Math.abs(income)],
        },
        {
          name: "Expenses",
          color: "#1AA8E9",
          data: [Math.abs(expense)],
        },
      ];
    });

    const firstTimerChart = computed(() => {
      firstTimerAttendanceData.value = [];

      firstTimerAttendanceData.value.push({
        name: "First Timer",
        color: `#1AA8E9`,
        data: [singleBranchInfo.value.firstTimerCount],
      });
      return firstTimerAttendanceData.value;
    });
    const chartItemdropdown = ref([
      { name: "Weekly", id: 2 },
      { name: "Monthly", id: 3 },
    ]);

    const chartItemdropdown2 = ref([
      { name: "Weekly", id: 2 },
      { name: "Monthly", id: 3 },
    ]);

    // const selectedType2 = (item) => {
    //   selectedWeekly.value = item;
    //   if (item.name === "Weekly") {
    //     firstTimerWeeklyAtt.value = true;
    //     firstTimerMonthlyAtt.value = false;
    //     getBranchTenantDashboard();
    //   }
    //   if (item.name === "Monthly") {
    //     firstTimerWeeklyAtt.value = false;
    //     firstTimerMonthlyAtt.value = true;
    //     getBranchTenantDashboard();
    //   }
    // };
    // const selectedType3 = (item) => {
    //   selectedMonthly.value = item;
    //   if (item.name === "Weekly") {
    //     attendancerWeeklyAtt.value = true;
    //     attendancerMonthlyAtt.value = false;
    //     getBranchTenantAttendance();
    //   }
    //   if (item.name === "Monthly") {
    //     attendancerWeeklyAtt.value = false;
    //     attendancerMonthlyAtt.value = true;
    //     getBranchTenantAttendance();
    //   }
    // };
    // const selectedType1 = (item) => {
    //   selectedMonthly.value = item;
    // };

    return {
      incomeColour,
      expenseColour,
      images,
      chartData,
      chartData2,
      incomeExpenseWeeklyData,
      attendanceDataExist,
      weeklyIncomeExpense,
      monthlyIncomeExpense,
      weeklyFirstTimer,
      monthlyFirstTimer,
      monthlyAttendance,
      weeklyAttendance,
      incomeExpenseSeries,
      firstTimerSeries,
      attendanceSeries,
      incomeExpenseBoolean,
      incomeExpenseBooleanMont,
      firstTimerBoolean,
      attendanceBoolean,
      attendanceBooleanMont,
      firstTimerBooleanMont,
      series3,
      donutData,
      donutData2,
      allReport,
      navigatorLang,
      membershipReports,
      allReport,
      attendanceReports,
      serviceReports,
      incomeExpReport,
      offerinConReport,
      selectedAction,
      tenantInfoExpenseBreakDown,
      tenantInfoIncomeBreakDown,
      tenantInfoFirstTimerMonthly,
      incomeBreakDownChartData,
      expenseBreakDownChartData,
      weeklyFirstTimerObj,
      monthlyFirstTimerObj,
      incomeExpenseMonthlyData,
      tenantInfoFirstTimerWeekly,
      tenantInfoAttendanceWeekly,
      tenantInfoAttendanceMonthly,
      tenantInfoIncomeExpenseMonthly,
      tenantInfoIncomeExpenseWeekly,
      branchId,
      // selectedType2,
      // selectedType3,
      firstTimerMonthlyAtt,
      firstTimerWeeklyAtt,
      attendancerMonthlyAtt,
      MemberAttDataExist,
      attendancerWeeklyAtt,
      monthlyAttendanceObj,
      displayWhatsappDrawer,
      whatsappClientState,
      firstTimerDataExist,
      incomeExpenseDataExist,
      weeklyAttendanceObj,
      sendWhatsappToMultiple,
      networkError,
      mdAndUp,
      lgAndUp,
      xlAndUp,
      series1,
      xsOnly,
      toggleEMAIL,
      toggleSMS,
      // selectedType1,
      chartItemdropdown,
      chartItemdropdown2,
      getAllAverageIncome,
      sendingwhatsappmessage,
      allBranches,
      getAllAverageAttendance,
      incomeExpenseChart,
      getTotalPeople,
      loading,
      selectedMonthly,
      selectedWeekly,
      series2,
      branchItem,
      series,
      firstTimerAttendanceData,
      showWhatsapp,
      singleBranchInfo,
      showSMS,
      showEmail,
      firstTimerData,
      firstTimerChart,
      firstTimerHeader,
      MemberAttendanceHeader,
      monthXaxis,
      xAxis,
      incomeData,
      expenseData,
      tenantInfo,
      IncomeExpHeader,
      mainIncomeExpenseData,
      primarycolor,
    };
  },
};
</script>

<style scoped>
.week {
  border-radius: 20px;
  background: #0b55d4;
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
}
.month {
  border-radius: 20px;
  background: #ececec;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
}
.weekly {
  cursor: pointer;
}

.active {
  color: #ffffff;
  transform: translateX(15%);
  z-index: 99;
  width: 100%;
  transition: all 0.3s ease-in-out;
}
.active2 {
  color: #000000;
  background: #ececec;
  transform: translateX(90%);
  z-index: 99;
  width: 100%;
  transition: all 0.3s ease-in-out;
}
.active3 {
  color: #ffffff;
  transform: translateX(-90%);
  background: #0b55d4;
  z-index: 99;
  width: 100%;
  transition: all 0.3s ease-in-out;
}
.active4 {
  color: #000000;
  transform: translateX(0%);
  width: 100%;
  transition: all 0.3s ease-in-out;
}
.branch-corner {
  border-radius: 0.5rem;
  background: #f3f3f3;
}
.card-title {
  font-size: 30px !important;
  margin: 0;
  color: #000000;
}
.card-text {
  margin: 0;
  font-size: 17px !important;
  font-weight: 300 !important;
  color: #000000 !important;
}

.btn-outline-primary {
  background-color: #e0f7fa;
  color: #333;
  border: none;
  padding: 10px 20px;
  display: flex;
  align-items: center;
}

.btn-outline-primary i {
  margin-right: 8px;
  font-size: 18px;
}

.no-person {
  height: 80vh;
  display: flex;
  text-align: center;
}

.empty-img {
  width: 85%;
  margin: auto;
}

.empty-img img {
  width: 100%;
  max-width: 200px;
}

.border-round {
  border-radius: 5rem;
}

.adjust-view {
  position: relative;
  top: 35px;
  right: 10px;
  z-index: 1;
}

.card-summary {
  border-radius: 8px;
  background: #f8f8f8;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@media (max-width: 767px) {
  .top-row {
    display: flex;
    flex-direction: column;
  }

  .box {
    margin-top: 30px;
  }

  .adjust-view {
    display: none;
  }
  .adjust-view2 {
    display: none;
  }

  .container-fluid-mobile {
    border: 1px solid !important;
    width: 85% !important;
    box-shadow: 0px 1px 4px #b1bfce45 !important;
    border-radius: 30px;
    border: 1px solid #dde2e6 !important;
  }
}
.adjust-view {
  position: relative;
  top: 80px;
  right: 10px;
  z-index: 1;
}
.adjust-view2 {
  position: relative;
  top: 100px;
  right: 10px;
  z-index: 1;
}

@media (max-width: 575px) {
  .adjust-view {
    left: 65px;
    top: 130px;
  }
  .adjust-view2 {
    left: 65px;
    top: 130px;
  }

  .view-report {
    display: none;
  }
}
@media (max-width: 705px) {
  .can-do-links {
    display: flex;
    flex-direction: column;
  }
  .adjust-view {
    left: 65px;
    top: 130px;
  }
  .adjust-view2 {
    left: 65px;
    top: 130px;
  }

  .view-report {
    display: none;
  }
}
@media (max-width: 767px) {
  .adjust-view {
    position: relative;
    top: 113px;
    right: 10px;
    z-index: 1;
  }
  .adjust-view2 {
    position: relative;
    top: 126px;
    right: 10px;
    z-index: 1;
  }

  .view-report {
    display: none;
  }
}
</style>
